/* eslint-disable @typescript-eslint/no-this-alias */
import React from 'react';
import {createRoot} from 'react-dom/client';
import HotelsGroupsSelector from './HotelsGroupsSelector'

const HotelsGroupsSelectorRoot = (props) => {
    return <HotelsGroupsSelector {...props} />;
}

if(typeof window.HotelsGroupsSelectorRoots == 'undefined') {
    window.HotelsGroupsSelectorRoots = {};
}

// MOUNT/UNMOUNT OK

window.HotelsGroupsSelectorRoot = function (sectionTag = 'global') {
    let allElts = document.querySelectorAll('[data-react="hotels-groups-selector"]');
    for (const element of allElts) {

        const uniqueId = element.dataset.windowId || sectionTag;

        if (window.HotelsGroupsSelectorRoots[uniqueId] && window.HotelsGroupsSelectorRoots[uniqueId].unmount) {
            window.HotelsGroupsSelectorRoots[uniqueId].unmount();
        }

        let attr = {};
        attr.label = element.dataset.label;
        attr.required = element.dataset.required === 'true';
        attr.values = JSON.parse(element.dataset.values ?? '[]');

        attr.name = element.getAttribute('name');
        element.removeAttribute('name');

        attr.trad = TRAD.HotelsGroupsSelector ?? {}

        // Traductions
        if (element.dataset.placeholder && element.dataset.placeholder != '') {
            attr.trad.placeholder = element.dataset.placeholder;
        }

        const root = createRoot(element);
        root.render(<HotelsGroupsSelectorRoot {...attr} />);
        
        window.HotelsGroupsSelectorRoots[uniqueId] = root;
    }
}